import { QualityMediumIcon } from './QualityMediumIcon';

/**
 * author: Michael Irigoyen
 * id C987C0CA-2D23-427B-8F9C-F3E10B32156C
 * name quality-medium
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/quality-medium.svg
 * tags
 */
export const MediumQualityIcon = QualityMediumIcon;
export default MediumQualityIcon